export * from './ddc-tabs-chips.component'
